import { createUploadImage } from './uploadImage';
export function createImagesApi(params) {
    return {
        uploadImage: createUploadImage(params),
    };
}
